import { RadioGroupState } from 'react-stately'

import { createContextAndHook } from '../utils/create-context'

export const [RadioGroupStateContext, useRadioGroupStateContext] =
  createContextAndHook<RadioGroupState>()
